
import apiClient from '../axios'
import { getUrl } from './index'

export const getTenantPrivacy = async (): Promise<any> => {
  const response = await apiClient.get(getUrl('/api/tenant/privacy'))
  return response.data
}

export const posTenantPrivacy = async (data: any): Promise<any> => {
  const response = await apiClient.post(getUrl('/api/tenant/privacy'), data)
  return response.data
}
